import { forwardRef, memo } from "react";

export const MegaphoneIcon = memo(
  forwardRef(function MegaphoneIcon(
    { size = 26, color = "currentColor", title, className, ...rest },
    ref,
  ) {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 21 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={title ? undefined : true}
        focusable="false"
        className={className}
        {...rest}
      >
        {title ? <title>{title}</title> : null}
        <path
          d="M20.3187 8.92656L12.0345 0.642351C11.1781 -0.214093 9.78444 -0.214141 8.92794 0.642351C8.15802 1.41222 8.09171 2.58639 8.66027 3.42482L8.64874 3.48248C8.05148 6.46905 6.59743 9.18604 4.44367 11.3397L0.643926 15.1395C-0.214569 15.998 -0.214715 17.3875 0.643926 18.246L2.71492 20.317C3.57336 21.1755 4.96291 21.1756 5.82146 20.317L6.33923 19.7992L9.96354 23.4236C10.822 24.2821 12.2115 24.2821 13.07 23.4236C13.9265 22.5671 13.9265 21.1735 13.07 20.3171L11.5168 18.7638L12.0345 18.246C12.893 17.3876 12.8931 15.9981 12.0345 15.1395L11.6827 14.7876C13.4136 13.5758 15.3793 12.7321 17.4786 12.3122L17.537 12.3005C18.3941 12.8792 19.5655 12.7862 20.3187 12.033H20.3187C21.1751 11.1766 21.1751 9.78306 20.3187 8.92656ZM4.78596 19.2815C4.49983 19.5676 4.03655 19.5677 3.75041 19.2815L1.67942 17.2105C1.39324 16.9243 1.39324 16.4612 1.67942 16.175L5.30368 12.5507L8.41022 15.6572C8.05563 16.0118 5.14929 18.9181 4.78596 19.2815ZM12.0345 21.3525C12.3199 21.638 12.3199 22.1025 12.0345 22.388C11.749 22.6735 11.2844 22.6735 10.999 22.388L7.37467 18.7637L8.41022 17.7282L12.0345 21.3525ZM9.44572 16.6927C9.66583 16.4726 9.99532 16.1354 10.5153 15.6913L10.999 16.175C11.2852 16.4612 11.2852 16.9243 10.999 17.2105L10.4812 17.7283L9.44572 16.6927ZM9.47682 14.6529L6.30798 11.484C8.00617 9.52314 9.22228 7.20845 9.87291 4.69381L16.267 11.0879C13.7524 11.7385 11.4378 12.9546 9.47682 14.6529ZM19.2831 10.9975C18.9969 11.2836 18.5337 11.2836 18.2476 10.9975L9.96344 2.71334C9.67726 2.42711 9.67726 1.96403 9.96344 1.67785C10.2496 1.39167 10.7128 1.39167 10.999 1.67785L19.2831 9.96191C19.5685 10.2474 19.5685 10.7119 19.2831 10.9975Z"
          fill={color}
        />
      </svg>
    );
  }),
);

MegaphoneIcon.displayName = "MegaphoneIcon";